import webStorageUtility from '../webstorageUtility';
/**
 * Get Cookie from List of cookies
 * @param {string} values
 * @param {string} cookieName
 */

var getCookieFromCookieList = function getCookieFromCookieList(values, cookieName) {
  var value = '';
  var cookiesArray = values.split(';');

  for (var i = 0; i < cookiesArray.length; i += 1) {
    var cookie = cookiesArray[i].trim();

    if (cookie.indexOf(cookieName) === 0) {
      value = cookie.substring(cookieName.length, cookie.length);
    }
  }

  return value;
};
/**
 * Get cookies from browser
 * @param {string} name
 * @param {boolean} decrypt
 */


export var getCookie = function getCookie(name) {
  var decrypt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!webStorageUtility.isCookieEnabled) return null;
  var cookieName = "".concat(name, "=");
  var value = getCookieFromCookieList(window.document.cookie, cookieName);
  return value ? webStorageUtility.getGettable(value, decrypt) : null;
};
/**
 * Get Cookies from request header. Should only be uses in server side.
 * @param {Request} req
 * @param {string} name
 * @param {boolean} decrypt
 */

export var getServerCookie = function getServerCookie(req, name) {
  var decrypt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!req.headers.cookie) return null;
  var cookieName = "".concat(name, "=");
  var value = getCookieFromCookieList(req.headers.cookie, cookieName);
  return value ? webStorageUtility.getGettable(value, decrypt) : null;
};
/**
 * Get All Cookies
 */

var getAll = function getAll(values, decrypt) {
  var pairs = values.split(';');
  if (pairs[pairs.length - 1] === '') return null;
  var cookies = {};

  for (var i = 0; i < pairs.length; i += 1) {
    var pair = pairs[i].split('=');
    cookies["".concat(pair[0]).trim()] = webStorageUtility.getGettable(pair[1], decrypt);
  }

  return cookies;
};
/**
 * Get All Cookies
 */


export var getAllCookies = function getAllCookies(req, decrypt) {
  return getAll(req ? req.headers.cookie : window.document.cookie, decrypt);
};
/**
 * Set cookies into browser.
 * @param {string} name
 * @param {any} value
 * @param {string} path
 * @param {number} expiry [in hrs.]
 * @param {boolean} encrypt
 */

export var setCookie = function setCookie(cookie) {
  if (!webStorageUtility.isCookieEnabled) return null;
  var name = cookie.name,
      value = cookie.value,
      cookiePrefix = cookie.cookiePrefix,
      path = cookie.path,
      expiry = cookie.expiry,
      encrypt = cookie.encrypt;
  var cookieName = cookiePrefix ? "".concat(cookiePrefix).concat(name) : name;
  var expires = '';
  var date = new Date();

  if (expiry) {
    date.setTime(date.getTime() + expiry * 1000 * 60 * 60 * 24);
    expires = "expires=".concat(date.toUTCString(), ";");
  }

  document.cookie = "".concat(cookieName, "=").concat(webStorageUtility.getSettable(value, encrypt), ";").concat(expires, ";path=").concat(path);
  return true;
};
/**
 * Remove cookies
 * @param {string} name
 */

export var removeCookie = function removeCookie(name) {
  if (!webStorageUtility.isCookieEnabled) return null;
  var date = new Date();
  date.setTime(date.getTime() - 1000 * 60 * 60 * 24);
  var expires = "expires=".concat(date.toString());
  document.cookie = "".concat(name, "=;").concat(expires);
  return true;
};